package com.r_estrategica.redacaoestrategica.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun SidebarComponent(
    currentScreen: Screen,
    onNavigate: (Screen) -> Unit
) {
    // Cores seguras para evitar problemas de renderização no Skiko
    val backgroundColor = Color(0xFF1E293B)
    val activeColor = Color(0xFF334155)
    val contentColor = Color.White

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .width(260.dp)
            .background(backgroundColor)
            .padding(16.dp)
    ) {
        // Logo / Header
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(bottom = 32.dp)
        ) {
            Box(
                modifier = Modifier
                    .size(40.dp)
                    .background(Color(0xFF1E88E5), RoundedCornerShape(8.dp))
            )
            Spacer(Modifier.width(12.dp))
            Text(
                "Redação Estratégica",
                color = contentColor,
                fontWeight = FontWeight.Bold,
                fontSize = 18.sp
            )
        }

        // Itens de Navegação
        SidebarItem(
            label = "Início",
            icon = Icons.Default.Home,
            isSelected = currentScreen is Screen.Dashboard,
            onClick = { onNavigate(Screen.Dashboard) }
        )

        // MISSÃO: Substituindo ícone customizado por Icons.Default.List para evitar Paint crash
        SidebarItem(
            label = "Trilha de Aprendizagem",
            icon = Icons.Default.List, 
            isSelected = currentScreen is Screen.LearningPath,
            onClick = { onNavigate(Screen.LearningPath) }
        )

        SidebarItem(
            label = "Gerador de C5",
            icon = Icons.Default.Edit,
            isSelected = currentScreen is Screen.InterventionGenerator,
            onClick = { onNavigate(Screen.InterventionGenerator) }
        )

        SidebarItem(
            label = "Banco de Agentes",
            icon = Icons.Default.Groups,
            isSelected = currentScreen is Screen.AgentesIntervencao,
            onClick = { onNavigate(Screen.AgentesIntervencao) }
        )

        SidebarItem(
            label = "Sinônimos",
            icon = Icons.Default.Psychology,
            isSelected = currentScreen is Screen.Sinonimos,
            onClick = { onNavigate(Screen.Sinonimos) }
        )
    }
}

@Composable
private fun SidebarItem(
    label: String,
    icon: ImageVector,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    // IMPORTANTE: Evitando Modifier.shadow ou Modifier.graphicsLayer aqui
    val bgColor = if (isSelected) Color(0xFF334155) else Color.Transparent
    val tintColor = if (isSelected) Color(0xFF64B5F6) else Color(0xFF94A3B8)

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp)
            .background(bgColor, RoundedCornerShape(12.dp))
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 12.dp)
    ) {
        Icon(
            imageVector = icon,
            contentDescription = null,
            tint = tintColor,
            modifier = Modifier.size(24.dp)
        )
        Spacer(Modifier.width(12.dp))
        Text(
            text = label,
            color = if (isSelected) Color.White else Color(0xFF94A3B8),
            fontSize = 14.sp,
            fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Medium
        )
    }
}
